<template>
<div>
  <simple-menu class="menu-left" :header="item.header" :items="item.items" :key="index" v-for="item, index in items"></simple-menu>
</div>
</template>
<script>
import SimpleMenu from './SimpleMenu.vue'
export default {
  components: {SimpleMenu},
  props: {
    items: {
      type: Array,
      default: []
    }
  }
}
</script>


// WEBPACK FOOTER //
// LeftMenu.vue?7ff38119